import { useTranslations } from '@vocab/react';
import { Button, Inline, Stack, Text } from 'braid-design-system';

import { CREATE_RESUME_PAGE } from 'src/components/Router';
import { Link } from 'src/components/Router/Link';
import { analyticsClient } from 'src/modules/analytics';
import { useAppConfig } from 'src/modules/appConfig';

import translations from './.vocab';

export const CreateResumeCTA = () => {
  const { t } = useTranslations(translations);
  const { brand } = useAppConfig();

  return (
    <Stack space="small">
      <Text>{t('Create a new resumé from your brand profile', { brand })}</Text>
      <Inline space="none">
        <Link
          page={CREATE_RESUME_PAGE}
          component={Button}
          tone="formAccent"
          data={{ automation: 'profile-start-resume-button' }}
          onClick={analyticsClient.profileCreateResumeButtonClicked}
        >
          {t('Create resumé')}
        </Link>
      </Inline>
    </Stack>
  );
};
